import * as React from 'react'

import { Box, Link, Text, useToggle } from '@factorialco/deprecated-design-system'
import { ExpenseBankingTransactionForExpenseDetailFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { transactionURL } from 'modules/expenses/lib/transactions/transactionUrl'

interface ExpenseTransactionTagProps {
  transaction?: ExpenseBankingTransactionForExpenseDetailFragment
}

const ExpenseTransactionTag = ({ transaction }: ExpenseTransactionTagProps) => {
  const { navigation } = useNavigation()
  const [modalOpen, toggleModal] = useToggle()

  return (
    <Box justifyContent="flexEnd">
      <Box gap="s6" flexDirection="row" alignItems="center" flexWrap="wrap">
        <Text.Normal weight="normal" size="200">
          {i18n.t('expenses_v2.modals.detail.transaction')}
        </Text.Normal>
        {transaction ? (
          <Link.Router external to={transactionURL(transaction, navigation)}>
            {i18n.t('expenses_v2.modals.detail.see_transaction')}
          </Link.Router>
        ) : (
          <Link.Touchable onClick={toggleModal(true)}>
            {i18n.t('expenses_v2.modals.detail.see_transaction')}
          </Link.Touchable>
        )}
      </Box>

      {modalOpen && (
        <Modal
          illustration="money-bag"
          title={i18n.t('expenses_v2.modals.detail.pending_transaction.title')}
          description={i18n.t('expenses_v2.modals.detail.pending_transaction.description')}
          onClose={toggleModal(false)}
        />
      )}
    </Box>
  )
}

export default ExpenseTransactionTag
